var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.063 1.753a.56.56 0 0 0-.563.562c0 .312.25.563.563.563h7.874c.312 0 .563-.251.563-.563a.56.56 0 0 0-.562-.562zM7.41 4.93a.56.56 0 0 0-.82 0l-3 3.187a.563.563 0 0 0 .818.771l2.03-2.156v4.957a.561.561 0 1 0 1.125 0V6.733L9.59 8.887a.563.563 0 0 0 .818-.771l-3-3.188z"
  })));
};
export default SvgUpload;